export const CUSTOMER_NOTIFICATIONS_LIST_LIMIT = 20;

/** Contact page list size (single fetch — infinite scroll + server actions remount-loop). */
export const CUSTOMER_NOTIFICATIONS_CONTACT_LIMIT = 100;

/** @deprecated Prefer CONTACT_LIMIT; kept for InfiniteList helpers. */
export const CUSTOMER_NOTIFICATIONS_PAGE_SIZE = 20;

/** Prefetch / auto-show: only the newest notification by publishedAt. */
export const CUSTOMER_NOTIFICATIONS_LATEST_LIMIT = 1;

export const customerNotificationsQueryKeyRoot = ['CUSTOMER_NOTIFICATIONS'] as const;
